/* ==========================================================================
   MonteCarlo SW — Custom JavaScript
   ==========================================================================
   All custom JS for the MonteCarlo Dawn theme.
   This file is isolated from Dawn stock files to minimize merge conflicts
   when pulling upstream Dawn updates.
   ========================================================================== */

/* --------------------------------------------------------------------------
   Pre-order: change add-to-cart button text when template suffix is pre-order.
   Reads a <meta name="product-template-suffix"> tag injected by the
   custom-product-meta section.
   -------------------------------------------------------------------------- */
(function () {
  var meta = document.querySelector('meta[name="product-template-suffix"]');
  if (meta && meta.content === 'pre-order') {
    document.addEventListener('DOMContentLoaded', function () {
      var btn = document.querySelector('.product-form__submit span');
      if (btn) btn.textContent = 'Pre-Compra';
    });
  }
})();
